module.exports = __webpack_public_path__ + "static/media/icon-document.da236392.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-summary/icon-document.svg
// module id = 485
// module chunks = 0 1 2